import "../../App.css";
import "./Home.css"

const Home = () =>{

    return(

		<>
		<section className="showcase">
			<div className="container grid">
				<div className="showcase-text">
					<p>
						"Domov nie je miesto kde bývaš, ale miesto kde ti rozumejú."
					</p>
					<h1 className="al-c">JUSTÍNA, n.o.</h1>
				</div>

				<div className="showcase-img">
					<img src="images/header1.png" alt=""></img>
				</div>
			</div>
		</section>

        <section className="home">

            <div className="container about">
                <h1>O zariadení pre seniorov</h1>
                <p>
					Zariadenie pre seniorov JUSTÍNA, n.o.(ďalej len ZpS) začalo poskytovať svoje služby dňa 11.7.2007. Zariadenie celodennej - dvadsaťštyri hodinovej starostlivosti je určené fyzickým osobám, ktoré sú odkázané na pomoc inej fyzickej osoby.
				</p>
				<img src="images/about_img1.png" className="imgRight" alt=""/>
				<p>
					Zariadenie bolo vybudované v priestoroch bývalej základnej školy v Podlužanoch. Budova prešla rozsiahlou rekonštrukciou. V priebehu roka 2008 a 2009 došlo ešte k niektorým úpravám. Okná boli vymenené za plastové a doplnené sieťkami proti hmyzu. V roku 2014 sa zariadenie napojilo na miestnu kanalizáciu. Pozitívnou zmenou bola revitalizácia záhrady o rozlohe 800 m2. V budove sa nachádzajú dvoj lôžkové, troj lôžkové a štvor lôžkové izby. Jedna izba je riešené s priamym dvadsaťštyri hodinovým dohľadom sestry. Pre dve izby slúži jedno sociálne zariadenie, ktoré pozostáva zo sprchy a WC. Klientom je umožnené priniesť si časť obľúbeného nábytku (kreslo,stolička, televízia, rozhlas a pod.). Spoločenská miestnosť je vybavená kreslami na pohodlné sedenie.
				</p>
				<p>
					V zariadení sa nachádzajú aj ďalšie priestory – sesterská izba, sklad na prádlo, miestnosť na upratovania a pranie, kuchyňa, jedáleň, príručné sklady a sociálne zariadenie pre zamestnancov. V letných mesiacoch slúži klientom na posedenie terasa, lavička pod stromami, lavičky v záhrade, kde je dostatok priestoru na prechádzky. ZpS má z troch strán uzatvorené nádvorie, ktoré je esteticky upravené okrasnými rastlinami.
				</p>
            </div>
        </section>
		</>
    );
}

export default Home;